// Coordenação remota (3394 Monolíngue / 3395 Bilíngue): feita pelo time da Access e paga no Brasil — nunca leva
// IOF/IR, taxa de remessa nem a NF Access da coordenação no exterior, para qualquer cliente (Vanessa 14/10).
// Espelho de OrcamentoRemessaEstimativa::coordenacaoRemota (API).
export const isCoordenacaoRemota = (produto) => {
    if (!produto || typeof produto !== 'object') return false;
    if (['3394', '3395'].includes(String(produto.codigo ?? '').trim())) return true;
    const nome = String(produto.nome ?? produto.label ?? '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toUpperCase().replace(/^\d+\s*-\s*/, '');
    return nome.startsWith('COORDENACAO REMOTA');
};
